var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingleClientHeaderBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 703 780",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_348_25369)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    opacity: 0.7,
    filter: "url(#filter0_f_348_25369)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M421.347 88.3945C571.869 187.018 570.437 282.544 550.906 317.979C512.95 388.107 552.849 513.613 637.959 532.815C723.068 552.016 853.621 547.285 898.085 436.25C942.548 325.214 858.416 206.665 749.434 1.56983C640.452 -203.526 711.53 -239.981 661.772 -360.756C612.015 -481.532 296.349 -503.238 249.944 -360.756C203.54 -218.275 233.196 -34.8854 421.347 88.3945Z",
    fill: "url(#paint0_linear_348_25369)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M421.347 88.3945C571.869 187.018 570.437 282.544 550.906 317.979C512.95 388.107 552.849 513.613 637.959 532.815C723.068 552.016 853.621 547.285 898.085 436.25C942.548 325.214 858.416 206.665 749.434 1.56983C640.452 -203.526 711.53 -239.981 661.772 -360.756C612.015 -481.532 296.349 -503.238 249.944 -360.756C203.54 -218.275 233.196 -34.8854 421.347 88.3945Z",
    stroke: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_348_25369",
    x: -19.9004,
    y: -710.134,
    width: 1180.63,
    height: 1502.13,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_348_25369"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_348_25369",
    x1: 158.989,
    y1: -256.707,
    x2: 827.356,
    y2: -235.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E42DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#5BB099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336268,
    stopColor: "#67D2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632216,
    stopColor: "#3D78D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81533,
    stopColor: "#212477"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_348_25369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 703,
    height: 779,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 779.514)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingleClientHeaderBg);
export default __webpack_public_path__ + "static/media/single-client-header-bg.7bc636ff2efc03677441f850c7afa4a0.svg";
export { ForwardRef as ReactComponent };